import linkerScript from "refractor/linker-script";
export default linkerScript;